import createFormSender from '../../modules/ajax-form-sender';
import createValidator from '../../modules/validator';

const SELECTOR = '.js-ajax-form';
const map = new WeakMap<
    HTMLFormElement,
    {
        sender: ReturnType<typeof createFormSender>;
        submitFn: EventListener;
        focusFn: EventListener;
    }
>();

const showMessage = (form: HTMLFormElement, message = '', success: boolean) => {
    const formMessage = form.querySelector<HTMLElement>('.js-form-message');

    if (formMessage) {
        formMessage.hidden = false;
        formMessage.innerHTML = message;
    }

    if (success) {
        formMessage?.classList.remove('is-error');
    } else {
        formMessage?.classList.add('is-error');
    }
};

const hideFormMessages = (form: HTMLFormElement) => {
    const formMessage = form.querySelector<HTMLElement>('.js-form-message');

    if (formMessage) {
        formMessage.hidden = true;
        formMessage.classList.remove('is-error');
    }
};

const clearAntispamInput = (form: HTMLFormElement) => {
    const checkInput = form.querySelector<HTMLInputElement>('input[name="check_val"]');
    if (checkInput) {
        checkInput.value = '';
    }
};

async function init() {
    const forms = Array.from(document.querySelectorAll<HTMLFormElement>(SELECTOR));

    forms.forEach((form) => {
        let isSubmitting = false;
        let hideTimeout: NodeJS.Timeout;
        const validator = createValidator(form, {
            scrollToInvalidInputOptions: {
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            },
        });
        const sender = createFormSender(form, {
            shouldClearInputs: true,
            onBeforeSend: () => {
                clearAntispamInput(form);
            },
            onSuccess: (response) => {
                showMessage(form, response.message, response.success);
            },
            onError: () => {
                showMessage(form, 'Произошла ошибка при отправке формы', true);
            },
            onComplete: () => {
                clearTimeout(hideTimeout);
                hideTimeout = setTimeout(() => hideFormMessages(form), 5000);
            },
        });

        function submitFn(event: Event) {
            if (isSubmitting) return;
            event.preventDefault();

            const isFormValid = validator.validate();

            if (isFormValid) {
                isSubmitting = true;

                sender.send().finally(() => {
                    isSubmitting = false;
                });
            }
        }

        function onFocus(this: HTMLInputElement) {
            validator.clearInput(this);
        }

        validator.inputs.forEach((input) => {
            input.addEventListener('focus', onFocus);
        });
        form.addEventListener('submit', submitFn);
        map.set(form, { sender, submitFn, focusFn: onFocus });
    });
}

function destroy() {
    const forms = Array.from(document.querySelectorAll<HTMLFormElement>(SELECTOR));

    forms.forEach((form) => {
        const data = map.get(form);

        if (data) {
            form.removeEventListener('submit', data.submitFn);
            Array.from(form.querySelectorAll('input')).forEach((input) => {
                input.removeEventListener('focus', data.focusFn);
            });
        }
    });
}

function getInstanceByElement(element: HTMLFormElement) {
    return map.get(element);
}

const _module = { init, destroy, getInstanceByElement };

export default _module;
